var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7527_23438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7527_23438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4825 6.6033V15.0904C17.4825 15.4558 17.353 15.7705 17.094 16.0343C16.835 16.2982 16.5179 16.4302 16.1428 16.4302H3.65567C3.29028 16.4302 2.97564 16.2982 2.71175 16.0343C2.44786 15.7705 2.31592 15.4558 2.31592 15.0904V6.6033C2.31592 6.23791 2.44786 5.92327 2.71175 5.65938C2.97564 5.39549 3.29028 5.26355 3.65567 5.26355H16.1428C16.5179 5.26355 16.835 5.39549 17.094 5.65938C17.353 5.92327 17.4825 6.23791 17.4825 6.6033ZM3.39923 8.18343H16.3992V6.6033C16.3992 6.53919 16.3725 6.48042 16.3191 6.42699C16.2657 6.37357 16.2069 6.34686 16.1428 6.34686H3.65567C3.59156 6.34686 3.53279 6.37357 3.47936 6.42699C3.42594 6.48042 3.39923 6.53919 3.39923 6.6033V8.18343ZM3.39923 10.5103V15.0904C3.39923 15.1545 3.42594 15.2133 3.47936 15.2667C3.53279 15.3202 3.59156 15.3469 3.65567 15.3469H16.1428C16.2069 15.3469 16.2657 15.3202 16.3191 15.2667C16.3725 15.2133 16.3992 15.1545 16.3992 15.0904V10.5103H3.39923Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.0d6e3fcac8d9fc58616234b1ba9c92de.svg";
export { ForwardRef as ReactComponent };